import { Locale } from "@lookiero/sty-psp-locale";
const SIZES = {
    [Locale.en_GB]: [
        { size: "6/XS", jeans: "25", bust: "32-33", waist: "24.5-25.5", hip: "34.5-35.5" },
        { size: "8/S", jeans: "26-27", bust: "33.5-34.5", waist: "26-27", hip: "36-37" },
        { size: "10/M", jeans: "28-29", bust: "35-37", waist: "27.5-29", hip: "37.5-39" },
        { size: "12/L", jeans: "30-31", bust: "37.5-39.5", waist: "29.5-31", hip: "39.5-41.5" },
        { size: "14/XL", jeans: "32-33", bust: "40-42", waist: "31.5-34", hip: "42-44" },
        { size: "16/XXL", jeans: "4", bust: "42.5-44", waist: "34.5-38", hip: "44.5-47" },
        { size: "18/3XL", jeans: "36", bust: "44.5-47", waist: "37.5-40", hip: "47.5-50" },
        { size: "20/4XL", jeans: "38", bust: "47.5-50", waist: "40.5-43.5", hip: "50.5-53" },
    ],
    default: [
        { size: "34/XS", jeans: "25", bust: "80-83", waist: "63-65", hip: "87-90" },
        { size: "36/S", jeans: "26-27", bust: "84-88", waist: "66-69", hip: "91-94" },
        { size: "38/M", jeans: "28-29", bust: "89-94", waist: "70-74", hip: "95-99" },
        { size: "40/L", jeans: "30-31", bust: "95-100", waist: "75-79", hip: "100-105" },
        { size: "42/XL", jeans: "32-33", bust: "101-106", waist: "80-86", hip: "106-112" },
        { size: "44/XXL", jeans: "34", bust: "107-112", waist: "87-94", hip: "113-119" },
        { size: "46/3XL", jeans: "36", bust: "113-119", waist: "95-102", hip: "120-127" },
        { size: "48/4XL", jeans: "38", bust: "120-126", waist: "103-110", hip: "128-135" },
    ],
};
const LEG_LENGTH_SIZES = {
    [Locale.en_GB]: [
        { length: "30", legLength: "29", height: `5" 3' - 5" 5'` },
        { length: "32", legLength: "31", height: `5" 5' - 5" 8'` },
        { length: "34", legLength: "33", height: `5" 8' +` },
    ],
    default: [
        { length: "30", legLength: "74", height: "160-164" },
        { length: "32", legLength: "79", height: "165-173" },
        { length: "34", legLength: "84", height: "+174" },
    ],
};
export { SIZES, LEG_LENGTH_SIZES };
